// extracted by extract-css-chunks-webpack-plugin
module.exports = {"auto_title":"auto_title-pCjqMlXz"};